import React from 'react';
import styled from 'styled-components';
import Heading from '../heading/Heading';
import StoloLogo from '../stofflove-logo-q';

const FabricRecommendation = ({ sewpat }) => {
    const StyledDescription = styled.div`
        margin-bottom: ${props => props.theme.space[13]};
        display: grid;
        grid-template-columns: 1fr 25vw;
        align-items: start;

        & .stolo-logo {
          margin: 0 1em 1em 1em;
          width: 98%;
          height: auto;
          max-width: 125px;
          max-height: 125px;
        }
    `;

    return (
        <React.Fragment>
            <StyledDescription className='clearfix'>
                <div>
                    <Heading text={sewpat.fabricrecommendation.label} level={3} margin='0 0 1em 0'/>
                    {sewpat.fabricrecommendation.content}
                </div>
                <StoloLogo />
            </StyledDescription>
        </React.Fragment>
    );
};

export default FabricRecommendation;



// WEBPACK FOOTER //
// ./src/components/sewpat/FabricRecommendation.js